<template lang="html">
  <section class="actionbar menu_wkBox_back_box" :class="className">
    <div class="action-list">
      <slot name="buttons"> </slot>
    </div>
    <slot name="tips"></slot>
  </section>
</template>

<script>
export default {
  props: {
    status: {
      type: [String, Number],
      default: 0
    },
    className: {
      type: String,
      default: '' // wait-pay 待支付，样式不同
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.actionbar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  // height: rem(100px);
  z-index: 100;
  background: #fff;
  box-shadow: 0 -7px 14px 0 rgba(0, 0, 0, 0.03);
  .action-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: rem(20px) rem(24px);
    overflow: hidden;
    @include border(top);
    &::before {
      top: -1px;
    }
  }
  .btns {
    display: block;
    min-width: rem(144px);
    padding: 0 rem(24px);
    height: rem(60px);
    text-align: center;
    line-height: rem(60px);
    color: #fff;
    font-size: rem(24px);
    margin-left: rem(20px);
  }
  .btn-refund {
    @include border(all, #999, 1px, 30px);
    min-width: rem(144px);
    height: rem(60px);
    border-radius: rem(30px);
    font-size: rem(24px);
    color: #2a2a2a;
    line-height: rem(30px);
  }
  .btn-pink {
    min-width: rem(144px);
    height: rem(60px);
    border-radius: rem(30px);
    background-image: linear-gradient(90deg, #ff5900 0%, #ff8800 100%);
    font-size: rem(24px);
    color: #fff;
    line-height: rem(30px);
  }
  .btn-cancel {
    @include border(all, #999, 1px, 30px);
    background: #fff;
    font-size: rem(24px);
    color: #2a2a2a;
    line-height: rem(30px);
  }
  .btn-pink-empty {
    min-width: rem(144px);
    height: rem(60px);
    font-size: rem(24px);
    color: #fff;
    line-height: rem(30px);
    color: #ff5900;
    @include border(all, #ff5900, 1px, 30px);
  }

  .btn-grey {
    background: #999;
  }
  .btn-ccc {
    background: #cccccc;
  }
}
.rearAction {
  display: flex;
  padding-left: rem(20px);
  padding-right: rem(20px);
  justify-content: space-between;
  align-items: center;
  .action-list {
    width: 100%;
  }
}
.countdown {
  position: absolute;
  width: rem(340px);
  height: rem(67px);
  right: rem(44px);
  top: rem(-55px);
  padding-top: rem(12px);
  padding-left: rem(16px);
  box-sizing: border-box;
  background: url('~@/assets/images/order/bg_countdown.png') 0 0/100% 100%
    no-repeat;
  color: #ff6d00;
  line-height: rem(32px);
  font-size: rem(26px);
}
</style>
